<template>
  <span
    class="d-inline-block align-middle"
    :style="style"
  />
</template>

<script>
export default {
  props: ['colors', 'size'],

  data () {
    return {
      style: {
        'width': `${this.size}px`,
        'height': `${this.size}px`,
        'border-radius': '50%',
        'background-image': `linear-gradient(${this.colors[0]},${this.colors[1]})`,
      },
    };
  },
};
</script>
